import router from '@/router';
// Resources
import { authResource } from '../services/AuthResource';

// Concurrent pingAuth callers (route guard + DefaultContainer) share one request.
let pingAuthPromise = null;

export default {
	state: {
		auth: false,
		userDetails: {}
	},

	// = computed properties()
	// -> Filter or calculate 'state' in runtime
	getters: {

		// Gets all the userDetails from state
		getUserDetails(state)
		{
			return state.userDetails;
		},

		// Gets a parameter from the userDetails from state
		getUserInfo(state)
		{
			return (parameter) => {
				return state.userDetails[parameter];
			}
		},

		// Gets the auth status
		getAuthStatus(state)
		{
			return state.auth;
		},

		// Checks if the requested route permission is one of the logged in user's permissions
		checkPermission(state)
		{
			return (requiredPermission) => {
				// If a route doesnt require permission - like login, then allow
				console.log('requiredPermission:', requiredPermission);
				console.log('userPermissions:', state.userDetails);

				if (!requiredPermission)
				{
					return true;
				}

				// else check if the user's permissions have the requiredPermission
				return state.userDetails.permissions.includes(requiredPermission);
			}
		},


	},

	// = methods()
	// -> Calls mutations to update the state,
	// -> Actions never update the state directly
	actions: {

		async login({ commit }, { username, password })
		{

			try
			{
				var cors = await authResource.getCsrf();

				var api = await authResource.login(username, password);

				commit('SET_AUTH_STATUS', api.data.success);

				if(api.data.success)
				{
					console.log('push to /Welcome');
					router.push('/Welcome');
				}
				else
				{
					console.log('error: resetting state...', error);
					commit('RESET_STATE');
				}
			}
			catch(error)
			{
				console.log('login error', error);
				commit('RESET_STATE');
			}
		},

		async logout({ commit })
		{
			try
			{
				var api = await authResource.logout();
				console.log('logout-api', api);

				// Reset the state
				commit('RESET_STATE');

				router.push('/login');
			}
			catch(error)
			{
				console.log(error);
			}
		},

		unAuthenticateUser({ commit })
		{
			commit('RESET_STATE');
		},

		async pingAuth({ commit, state }, payload = {})
		{
			const force = !!(payload && payload.force);
			if (!force && state.userDetails && Object.keys(state.userDetails).length) {
				return true;
			}
			if (pingAuthPromise) {
				return pingAuthPromise;
			}

			pingAuthPromise = (async () => {
				try
				{
					var userDetails = await authResource.getUser();
					commit('SET_USER_DETAILS', userDetails.data);
					return true;
				}
				catch(error)
				{
					console.log('error: resetting state...', error);
					commit('RESET_STATE');
					router.push('/login');
				}
				finally
				{
					pingAuthPromise = null;
				}
			})();

			return pingAuthPromise;
		},
	},

	// = updates the state
	// -> Mutation always updates the state.
	mutations: {
		SET_AUTH_STATUS(state, authStatus)
		{
			state.auth = authStatus;
			console.log('SET_AUTH_STATUS:', state.auth);
		},

		SET_USER_DETAILS(state, payload)
		{
			state.userDetails = payload

			console.log('SET_USER_DETAILS DONE:', state);
		},

		RESET_STATE(state)
		{
			console.log('RESET_STATE');

			state.auth = false
			state.userDetails = {}
			pingAuthPromise = null;

			console.log('current-state:', state);
		}

	},
}
